import Home from "./pages/Home";

const App = () => {
	return (
		<div className="w-screen h-screen bg-[#F5F1E5]">
			<Home />
		</div>
	);
};

export default App;
